/* istanbul ignore file */
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useLeadUrl } from 'domain/shared/lead';

const EditLeadButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useLeadUrl();

  return <EditButton path={getUpdateEntityUrl} {...props} />;
};

export default EditLeadButton;
